/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = ReceiptMaterialDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialDetailsEditor extends _Ext.GridEditorBase<ReceiptMaterialDetailsRow> {



        protected getColumnsKey() { return "Production.ReceiptMaterialDetails"; }
        protected getDialogType() { return ReceiptMaterialDetailsDialog; }
        protected getLocalTextPrefix() { return ReceiptMaterialDetailsRow.localTextPrefix; }
        protected form: ReceiptMaterialDetailsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public DeptId: number;
        public LineNo: number;
        public BagNo: string;
        isEditable: boolean;
        // #endregion


        constructor(container: JQuery) {
            super(container);
          //  this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
            this.isEditable = this.slickGrid.getOptions().editable;
        }
        public Editable() {
            this.isEditable = true;
        } 
        // #region Column Add -Remove
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }
        protected getColumns() {

            var columns = super.getColumns();

            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion
        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row);

            //To Set Master Product Image
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    //if ( == 0) {
                    //    Q.alert("Voucher is ReadOnly can not Delete!!")
                    //}
                    //else {
                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {

                        var id = this.id(item);/*
                            var refid = Stock.StockItemRow.getLookup().items.filter(x => x.RefTransItemId == item.TransItemId && x.RefVoucherId == item.VoucherTypeId && x.RefTransId == item.TransId)[0];
                            if (refid != null) {
                                if (refid.PartyId != null || refid.PartyId > 0) {
                                    Q.alert("This Item has been used in transactions Cannot Delete!");
                                    return;
                                }
                            } else {

                              //  this.TotalItems = this.view.getItems().length - 1;
                            */    this.view.deleteItem(id); 
                    }
                    );

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }


        }

    }
}